"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name;
}

var WithModal = function WithModal(WrappedComponent) {
  var WithModalFn =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(WithModalFn, _React$Component);

    function WithModalFn(props) {
      var _this;

      WithModalFn.propTypes = {
        isOpen: _propTypes.bool
      };
      WithModalFn.defaultProps = {
        isOpen: false
      };
      _this = _React$Component.call(this, props) || this;
      (0, _reactAutobind.default)(_assertThisInitialized(_this));
      _this.state = {
        isOpen: props.isOpen
      };
      return _this;
    }

    var _proto = WithModalFn.prototype;

    _proto.openModal = function openModal() {
      this.setState({
        isOpen: true
      });
    };

    _proto.closeModal = function closeModal() {
      this.setState({
        isOpen: false
      });
    };

    _proto.render = function render() {
      WithModalFn.displayName = "HOC" + getDisplayName(WrappedComponent);
      return _react.default.createElement(WrappedComponent, _extends({}, this.props, {
        isOpen: this.state.isOpen,
        open: this.openModal,
        close: this.closeModal
      }));
    };

    return WithModalFn;
  }(_react.default.Component);

  WithModalFn.propTypes = {
    isOpen: _propTypes.bool
  };
  WithModalFn.defaultProps = {
    isOpen: false
  };
  return WithModalFn;
};

WithModal.modalProps = {
  isOpen: _propTypes.bool.isRequired,
  open: _propTypes.func.isRequired,
  close: _propTypes.func.isRequired
};
var _default = WithModal;
exports.default = _default;